/**
 * Utility function to export data to CSV and trigger download
 * @param data Array of objects to export
 * @param fileName Name of the file to download
 */
export const exportToCSV = (data: any[], fileName: string) => {
  if (!data || data.length === 0) {
    return;
  }

  // Extract headers
  const headers = Object.keys(data[0]);
  
  // Create CSV rows
  const csvRows = [
    // Header row
    headers.join(','),
    // Data rows
    ...data.map(row => 
      headers.map(header => {
        const value = row[header] === null || row[header] === undefined ? '' : row[header];
        // Handle values containing commas by wrapping in quotes
        const stringValue = String(value).replace(/"/g, '""');
        return `"${stringValue}"`;
      }).join(',')
    )
  ];

  // Combine rows into a single string
  const csvString = csvRows.join('\n');
  
  // Create a blob and download it
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
